/**
 * Extracts hostname from current URL.
 */
export const getHostname = (): string | undefined => {
  if (typeof window === 'undefined') return undefined;

  const hostname = window.location.hostname;
  return hostname;
};
